/* DPS (okt 2026): video's in de uitklaptab 'Video's'. De iframes staan met data-src in de HTML en krijgen hun src pas
   als de tab opengaat én zichtbaar is, zodat een dichte tab en de verborgen mobiele/desktop-kopie niets laden. */
(function () {
  function load(root) {
    if (!root || root.offsetParent === null) return; // verborgen kopie (andere breakpoint) niet laden
    root.querySelectorAll('.product-videos__frame[data-src]').forEach(function (f) {
      f.src = f.getAttribute('data-src');
      f.removeAttribute('data-src');
    });
  }
  function loadOpen(scope) {
    (scope || document).querySelectorAll('details[open] .product-videos').forEach(load);
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.tagName === 'DETAILS' && d.open) load(d.querySelector('.product-videos'));
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { loadOpen(); });
  else loadOpen();
  document.addEventListener('shopify:section:load', function (e) { loadOpen(e.target); });
})();
